import { P2GTextField, P2GGrid } from '@parcel2go/core-ui';
import { useMemo } from 'react';
import { Meta, MetaValue } from '~/lib/api/smartsend/types';
import SidePanelSection from '../../../../components/sidepanel-section';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { sanitiseKey } from '~/lib/utils/translation';

export interface EditMetaModel {
  key: string;
  meta: MetaValue;
}

interface props {
  onUpdate?: (meta: EditMetaModel) => void;
  meta: Meta;
  includeOrCreate: string[];
  readOnly: string[];
  title: string;
}

export const ItemMeta: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const meta = useMemo<EditMetaModel[]>(() => {
    const output: EditMetaModel[] = [];
    props.includeOrCreate.forEach((m) => {
      output.push({ key: m, meta: props.meta[m] || { Type: 'string', Value: '' } });
    });
    return output;
  }, [props.meta, props.includeOrCreate]);

  const readOnlymeta = useMemo<EditMetaModel[]>(() => {
    const output: EditMetaModel[] = [];
    props.readOnly.forEach((m) => {
      if (props.meta[m]) {
        output.push({ key: m, meta: props.meta[m] || { Type: 'string', Value: '' } });
      }
    });
    return output;
  }, [props.meta, props.readOnly]);

  if (meta.length === 0 && readOnlymeta.length === 0) {
    return null;
  }

  const translateLabel = (key: string) => {
    return <Trans t={t} i18nKey={sanitiseKey(`INPUT_${key}_LABEL`)} defaults={key} />;
  };

  return (
    <SidePanelSection title={props.title}>
      <P2GGrid container spacing={2}>
        {meta.map((x) => (
          <P2GGrid xs={12} item key={x.key}>
            <P2GTextField
              fullWidth
              id={x.key}
              label={translateLabel(x.key)}
              value={x.meta.Value}
              onChange={(v) => {
                props.onUpdate?.({ ...x, meta: { ...x.meta, Value: v.currentTarget.value } });
              }}
            />
          </P2GGrid>
        ))}
        {readOnlymeta.map((x) => (
          <P2GGrid xs={12} item key={x.key}>
            <P2GTextField
              fullWidth
              id={x.key}
              value={x.meta.Value}
              disabled
              onChange={() => {}}
              label={translateLabel(x.key)}
            />
          </P2GGrid>
        ))}
      </P2GGrid>
    </SidePanelSection>
  );
};
